import { Component, Injector, Input, OnInit } from '@angular/core';

@Component({
    selector: 'aumico-logged-out-layout',
    templateUrl: './logged-out-layout.component.html',
    styleUrls: ['./logged-out-layout.component.scss'],
})
export class LoggedOutLayout implements OnInit {
    @Input() introductionText: string;

    constructor(injector: Injector) {}

    ngOnInit() {}
}
